//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  childGrid: {
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  popover: {
    fontSize: "35px !important",
  },
  accountSummaryText: {
    textAlign: "left",
    // font: "normal normal ",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    "@media (max-width: 600px)": {
      display: "block",
      textAlign: "center",
    },
  },
  // -----------------------------Styles for view my statment component------------------------------
  input: {
    width: "30%"
  },
  exportBtn: {
    color: "#fff!important",
    width: 150,
    height: 40,
    fontSize: 18,
    fontFamily: "segoe-ui",
    borderRadius: 5,
    textTransform: "capitalize",
    backgroundColor: "#305698!important",
    margin: 10,
    outline: "none",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#305698!important",
    },
    "&:active": {
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
  },
  exportAndPreview: {
    marginBottom: 100,
    "@media (max-width: 768px)": {
      display: "flex",
      justifyContent: "center",
    },
  },
  headText: {
    fontSize: 20,
    fontWeight: "bold",
    fontFamily: "segoe-ui",
    letterSpacing: 1,
    "@media (max-width: 768px)": {
      textAlign: "center",
    },
  },
  inputsDiv: {
    padding: 15,
  },
  dateInput: {
    width: "90%",
  },
  //----------------------------------------------------------------------------//
  tabContainer: {
    width: "100%",
    height: 44,
    backgroundColor: "#2F7CBD",
    borderRadius: 5,
    marginTop: 10,
    "@media (max-width: 600px)": {
      overflow: "scroll",
      whiteSpace: "nowrap",
    },
  },
  tabsNameGrid: {
    alignSelf: "center",
  },
  tabsNameView: {
    padding: "0px 10px",
  },
  tabsName: {
    cursor: "pointer",
    fontSize: 15,
    color: "#fff",
  },
  tabsContainer: {
    marginTop: 5,
  },
  loyaltyBtnGrid: {
    "@media (max-width: 600px)": {
      textAlign: "center",
      padding: "10px 0px 0px 0px",
    },
  },
  loyaltyBtn: {
    color: "#fff",
    backgroundColor: "#2F7CBD",
    borderRadius: 10,
    // fontSize: 15,
    margin: 20,
    padding: 20,
    fontSize: 20,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  exportParentDiv: {
    color: "#fff",
    cursor: "pointer",
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
    position: "absolute",
    right: -10,
    top: -15,
  },
  dashboardSubheader: {
    fontSize: "1.125rem",
    color: "#7f7f7f",
    fontWeight: "bold",
  },
  pointsAvailable: {
    fontSize: "18px",
    color: "#7f7f7f",
    lineHeight: 1.3,
  },
  pointsAvailableNum: {
    fontSize: "1.5rem",
    lineHeight: 1.3,
  },
  alignGridRightOne: {
    justifyContent: "flex-end",
    // marginTop: "-56px",
    "@media (max-width: 768px)and (min-width: 500px)": {
      justifyContent: "flex-end",
    },
    "@media (max-width: 500px)": {
      justifyContent: "flex-start",
    },
  },
  alignGridRightTwo: {
    marginTop: "-46px",
    justifyContent: "flex-end",
    "@media (max-width: 768px) and (min-width: 500px)": {
      marginTop: 0,
      justifyContent: "flex-end",
    },
    "@media (max-width: 500px)": {
      justifyContent: "flex-start",
      marginTop: 100,
    },
  },
  dash_1_tab_1: {
    background: "#233d75",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: 5,
    fontSize: "12px",
    marginRight: 5,
    marginBottom: 5,
    cursor: "pointer",
    width: 90,
    fontWeight: "bold",
    "@media (max-width: 700px)": {
      width: 94,
    },
  },
  dash_1_tab_2: {
    background: "#0a72ba",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: 5,
    fontSize: "12px",
    marginRight: 5,
    marginBottom: 5,
    cursor: "pointer",
    width: 90,
    fontWeight: "bold",
    "@media (max-width: 700px)": {
      width: 94,
    },
  },
  earnedBtn: {
    marginRight: "0px !important",
    borderRadius: "10px 0px 0px 10px !important",
  },
  reedemBtn: {
    marginRight: "5px !important",
    borderRadius: "10px 10px 10px 10px !important",
  },
  earnedInput: {
    marginRight: 5,
    height: 47,
    width: 120,
  },
  redeemTodayDiv: {
    position: "relative",
    paddingTop: "0.7rem",
  },
  redeemTodayDivOne: {
    paddingTop: "0.7rem",
  },
  redeemBtnDiv: {
    position: "absolute",
    top: 10,
    left: "90%",
    "@media (max-width: 768px)": {
      top: "100%",
      left: 0,
      width: "100%",
    },
  },
  changeLoyaltyBtn: {
    fontSize: 16,
    color: "#fff",
    width: "30%",
    backgroundColor: "#4472c4",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    marginLeft: 20,
    "@media (max-width: 768px)": {
      width: "100%",
      marginLeft: 0,
    },
  },
  pendingPoints: {
    color: "#233d75 !important",
  },
  salesNonSales: {
    color: "#233d75 !important",
  },
  salseSpan: {
    marginLeft: 10,
    marginTop: 10,
    "@media (max-width: 500px)": {
      display: "flex",
    },
  },
  filterGrid: {},
  filterBtn: {
    height: 46,
    fontSize: "12px !important",
  },
  tripleDot: {
    marginTop: 10,
    "@media (max-width: 500px)": {},
  },
  viewMyActivityTabContainer: {
    height: 30,
    marginBottom: 20,
    display: "flex"
  },
  viewMyActivityTabContainerElement: {
    flex: 0.2,
    cursor: "pointer",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #ddd"
  },
  tabActive: {
    flex: 0.2,
    color: "#fff",
    cursor: "pointer",
    background: "#0a72ba",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  faqBtn: {
    border: 'none',
    color: '#fff',
    backgroundColor: '#cf661b',
    padding: '4px 8px',
    borderRadius: 5,
    cursor: 'pointer',
    marginTop: 10,
    "@media (max-width: 768px)": {
      width: '100%'
    },
  },
  clsBtn: {
    position: 'absolute',
    right: 8,
    top: 8
  },
  accordionQuestionTypography: {
    fontWeight: 600
  },
  accordionHeading: {
    textAlign: 'center'
  }
}));

export const myDashboardStyles = makeStyles((theme) => ({
  myDashCardSection: {
    display: "flex",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
}));

export const availablePointsStyles = makeStyles((theme) => ({
  availableDiv: {
    width: "60%",
    background: "#e8eaeb",
    borderRadius: "10px",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    lineHeight: 1,
    flexWrap: "wrap",
    padding: 3
    // height: 70,
  },
  availableDivOne: {
    width: "100%",
    background: "#e8eaeb",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    textAlign: "center",
    lineHeight: 1,
    flexWrap: "wrap",
    // height: 70,
  },
  redeemDiv: {
    width: "40%",
    background: " #40b2df",
    borderRadius: "10px",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "18px",
    cursor: "pointer",
    // height: 70,
  },
  redeemDivForCanada: {
    width: "70%",
    background: " #8f1e5f",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "18px",
    cursor: "pointer",
  },
  pointsToDollarBtn: {
    backgroundColor: "#4472c4",
    border: "none",
    fontSize: 16,
    color: "#fff",
    cursor: "pointer",
    borderRadius: 5,
    width: "80%",
    marginLeft: "5px",
    padding: "4px 8px",
  },
  reedemBtn: {
    marginRight: "5px !important",
    borderRadius: "10px 10px 10px 10px !important",
  },

  
}));
